import { connect } from 'react-redux';
import Settings from './Settings';

const mapState = ({ users }) => ({
  myData: users.myData,
});
export default connect(mapState)(Settings);
